const BASE_NAME = 'Employer | ';

export const SAJ_PAGE_NAMES = {
  Audit: 'Audit',
  Billing: 'Billing',
  Brands: 'Brands',
  Candidates: 'Candidates',
  CandidateDetails: 'Candidate details',
  CampaignPerformanceReport: 'Campaign Performance Report',
  CareerSites: 'Career Sites',
  Dashboard: 'Dashboard',
  FeaturedEmployer: 'Featured Employer',
  Feeds: 'Feeds',
  InterviewAvailability: 'Interview Availability',
  InterviewsScheduled: 'Interviews Scheduled',
  Locations: 'Locations',
  Promote: 'Campaigns',
  Positions: 'Positions',
  Postings: 'Postings',
  PostingCreate: 'Create new posting',
  PostingEdit: 'Edit posting',
  PostingPerformanceReport: 'Posting Performance Report',
  Profile: 'Profile',
  Permissions: 'Permissions',
  Users: 'Users',
};

export const SAJ_PAGE_TITLES = {
  Audit: BASE_NAME + SAJ_PAGE_NAMES.Audit,
  Billing: BASE_NAME + SAJ_PAGE_NAMES.Billing,
  Brands: BASE_NAME + SAJ_PAGE_NAMES.Brands,
  CandidateDetails: BASE_NAME + SAJ_PAGE_NAMES.Candidates + ' - ',
  Candidates: BASE_NAME + SAJ_PAGE_NAMES.Candidates,
  CampaignDetails: BASE_NAME + SAJ_PAGE_NAMES.Promote + ' - ',
  CampaignPerformanceReport:
    BASE_NAME + SAJ_PAGE_NAMES.CampaignPerformanceReport,
  CareerSites: BASE_NAME + SAJ_PAGE_NAMES.CareerSites,
  Dashboard: BASE_NAME + SAJ_PAGE_NAMES.Dashboard,
  FeaturedEmployer: BASE_NAME + SAJ_PAGE_NAMES.FeaturedEmployer,
  Feeds: BASE_NAME + SAJ_PAGE_NAMES.Feeds,
  Information: BASE_NAME + 'Information',
  InterviewAvailability: BASE_NAME + SAJ_PAGE_NAMES.InterviewAvailability,
  InterviewsScheduled: BASE_NAME + SAJ_PAGE_NAMES.InterviewsScheduled,
  Locations: BASE_NAME + SAJ_PAGE_NAMES.Locations,
  Positions: BASE_NAME + SAJ_PAGE_NAMES.Positions,
  Postings: BASE_NAME + SAJ_PAGE_NAMES.Postings,
  PostingCreate: BASE_NAME + SAJ_PAGE_NAMES.PostingCreate,
  PostingEdit: BASE_NAME + SAJ_PAGE_NAMES.PostingEdit,
  PostingPerformaneReport: BASE_NAME + SAJ_PAGE_NAMES.PostingPerformanceReport,
  Promote: BASE_NAME + SAJ_PAGE_NAMES.Promote,
  Profile: BASE_NAME + SAJ_PAGE_NAMES.Profile,
  Permissions: BASE_NAME + SAJ_PAGE_NAMES.Permissions,
  Users: BASE_NAME + SAJ_PAGE_NAMES.Users,
};
